import client from './client';

export const projectsApi = {
  // List all projects
  async list(params = {}) {
    const { data } = await client.get('/api/projects', { params });
    return data;
  },

  // Get single project by key
  async get(key) {
    const { data } = await client.get(`/api/projects/${key}`);
    return data;
  },

  // Create new project
  async create(project) {
    const { data } = await client.post('/api/projects', project);
    return data;
  },

  // Update project
  async update(key, updates) {
    const { data } = await client.patch(`/api/projects/${key}`, updates);
    return data;
  },

  // Archive project
  async archive(key) {
    const { data } = await client.patch(`/api/projects/${key}`, {
      archived: true,
    });
    return data;
  },

  // Restore archived project
  async restore(key) {
    const { data } = await client.patch(`/api/projects/${key}`, {
      archived: false,
    });
    return data;
  },

  // Get webhook configuration
  async getWebhook(key) {
    const { data } = await client.get(`/api/projects/${key}/webhook`);
    return data;
  },

  // Generate or regenerate webhook secret
  async generateWebhookSecret(key) {
    const { data } = await client.post(`/api/projects/${key}/webhook`);
    return data;
  },

  // Remove webhook secret
  async removeWebhookSecret(key) {
    const { data } = await client.delete(`/api/projects/${key}/webhook`);
    return data;
  },
};
